// extracted by mini-css-extract-plugin
export default {"container":"redaction_container__kl6eV","newQuizzesContainer":"redaction_newQuizzesContainer__HTK8w","textDraw":"redaction_textDraw__CYyzN"};